(function () {
  function initCarousel(root) {
    if (!root || root.dataset.wfCarouselInit === 'true') return;
    root.dataset.wfCarouselInit = 'true';

    var track = root.querySelector('[data-wf-carousel-track]');
    var prev = root.querySelector('[data-wf-carousel-prev]');
    var next = root.querySelector('[data-wf-carousel-next]');
    if (!track) return;

    var getStep = function () {
      var slide = track.querySelector('[data-wf-carousel-slide]');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return slide.offsetWidth + gap;
    };

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }
  }

  function initUgcGallery(root) {
    if (!root || root.dataset.wfUgcInit === 'true') return;
    root.dataset.wfUgcInit = 'true';

    var videos = root.querySelectorAll('[data-wf-ugc-video]');
    if (!videos.length) return;

    var loadVideo = function () {};

    var playVideo = function (video) {
      if (video.dataset.playing === 'true') return;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.then(function () {
          video.dataset.playing = 'true';
        }).catch(function () {});
      }
      var item = video.closest('.wf-ugc-gallery__item');
      if (item) item.classList.add('is-playing');
    };

    var pauseVideo = function (video) {
      video.pause();
      video.dataset.playing = 'false';
      var item = video.closest('.wf-ugc-gallery__item');
      if (item) item.classList.remove('is-playing');
    };

    var track = root.querySelector('[data-wf-carousel-track]');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
              playVideo(video);
            } else {
              pauseVideo(video);
            }
          });
        },
        {
          root: track || null,
          threshold: [0, 0.25, 0.5, 1],
          rootMargin: '0px 80px'
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      videos.forEach(function (video, index) {
        if (index < 2) playVideo(video);
      });
    }

    if (track) {
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          videos.forEach(function (video) {
            var rect = video.getBoundingClientRect();
            var trackRect = track.getBoundingClientRect();
            var visible = rect.right > trackRect.left + 20 && rect.left < trackRect.right - 20;
            if (visible) playVideo(video);
            else pauseVideo(video);
          });
        });
      }, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-wf-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-wf-ugc-gallery]').forEach(initUgcGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      event.target.querySelectorAll('[data-wf-carousel]').forEach(initCarousel);
      event.target.querySelectorAll('[data-wf-ugc-gallery]').forEach(initUgcGallery);
    }
  });
})();
